var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaPlatforms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2354_1209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4167C0 8.67091 0 6.29803 0.938221 4.49188C1.72885 2.96985 2.96985 1.72885 4.49188 0.938221C6.29803 0 8.67091 0 13.4167 0H26.5833C31.3291 0 33.702 0 35.5081 0.938221C37.0301 1.72885 38.2711 2.96985 39.0618 4.49188C40 6.29803 40 8.67091 40 13.4167V26.5833C40 31.3291 40 33.702 39.0618 35.5081C38.2711 37.0301 37.0301 38.2711 35.5081 39.0618C33.702 40 31.3291 40 26.5833 40H13.4167C8.67091 40 6.29803 40 4.49188 39.0618C2.96985 38.2711 1.72885 37.0301 0.938221 35.5081C0 33.702 0 31.3291 0 26.5833V13.4167Z",
    fill: "#1080F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4306 14.7251C17.8928 11.4938 15.7706 10.2624 13.2306 10.2624C8.05247 10.2624 4.08502 17.0013 4.08502 24.1339C4.08502 28.5975 6.24434 31.4125 9.86122 31.4125C12.4644 31.4125 14.3366 30.1854 17.6648 24.3674C17.6648 24.3674 19.0522 21.9174 20.0067 20.2296C20.3411 20.7696 20.6926 21.3506 21.0634 21.9751L22.6243 24.6007C25.6644 29.6884 27.3585 31.4125 30.4278 31.4125C33.9514 31.4125 35.9122 28.559 35.9122 24.0028C35.9122 16.5345 31.8554 10.2624 26.927 10.2624C24.3173 10.2624 22.2774 12.2281 20.4306 14.7251ZM25.3112 22.2596L23.4451 19.1474C22.9402 18.3261 22.4563 17.5713 21.9893 16.8794C23.671 14.2835 25.0584 12.9901 26.7083 12.9901C30.1361 12.9901 32.8785 18.037 32.8785 24.2361C32.8785 26.599 32.1044 27.9701 30.5008 27.9701C28.9638 27.9701 28.2295 26.9551 25.3112 22.2596ZM7.52731 24.1923C7.52731 19.0141 10.1091 13.7194 13.1869 13.7194C14.8535 13.7194 16.2462 14.6819 18.3796 17.736C16.3539 20.8432 15.1268 22.792 15.1268 22.792C12.4284 27.022 11.4949 27.9701 9.99257 27.9701C8.44628 27.9701 7.52731 26.6127 7.52731 24.1923Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2354_1209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaPlatforms);
export default __webpack_public_path__ + "static/media/MetaPlatforms.04297148acd3ed487ab02452edccdc18.svg";
export { ForwardRef as ReactComponent };